export default "__VITE_ASSET__DgJAUTu6__"